import { Regions } from '@smh/projects/regions';
import MskSvg from 'jtn-ui/svg/mobile-app-invite/1077.svg';
import UfaSvg from 'jtn-ui/svg/mobile-app-invite/2.svg';
import KrasnodarkSvg from 'jtn-ui/svg/mobile-app-invite/23.svg';
import KrasnoyarskSvg from 'jtn-ui/svg/mobile-app-invite/24.svg';
import ArkhangelskSvg from 'jtn-ui/svg/mobile-app-invite/29.svg';
import VolgogradSvg from 'jtn-ui/svg/mobile-app-invite/34.svg';
import KemerovoSvg from 'jtn-ui/svg/mobile-app-invite/42.svg';
import KurganSvg from 'jtn-ui/svg/mobile-app-invite/45.svg';
import NizhnyNovgorodSvg from 'jtn-ui/svg/mobile-app-invite/52.svg';
import NskSvg from 'jtn-ui/svg/mobile-app-invite/54.svg';
import OmskSvg from 'jtn-ui/svg/mobile-app-invite/55.svg';
import PermSvg from 'jtn-ui/svg/mobile-app-invite/59.svg';
import RostovSvg from 'jtn-ui/svg/mobile-app-invite/61.svg';
import SamaraSvg from 'jtn-ui/svg/mobile-app-invite/63.svg';
import YekaterinburgSvg from 'jtn-ui/svg/mobile-app-invite/66.svg';
import TyumenSvg from 'jtn-ui/svg/mobile-app-invite/72.svg';
import ChelyabinskSvg from 'jtn-ui/svg/mobile-app-invite/74.svg';
import ChitaSvg from 'jtn-ui/svg/mobile-app-invite/75.svg';
import YaroslavlSvg from 'jtn-ui/svg/mobile-app-invite/76.svg';
import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiBtn } from '@jtnews/jtn-ui';
import { injectStylesMixin, tsStoreMixin } from '@jtnews/shared';

import styles from './mobile-app-invite.styles.scss?module';

type Events = {
  onAppInviteMounted: void;
  onAppInviteClicked: void;
};

const REGION_SVG_MAP = {
  [2]: UfaSvg,
  [23]: KrasnodarkSvg,
  [24]: KrasnoyarskSvg,
  [29]: ArkhangelskSvg,
  [34]: VolgogradSvg,
  [42]: KemerovoSvg,
  [45]: KurganSvg,
  [52]: NizhnyNovgorodSvg,
  [54]: NskSvg,
  [55]: OmskSvg,
  [59]: PermSvg,
  [61]: RostovSvg,
  [63]: SamaraSvg,
  [66]: YekaterinburgSvg,
  [72]: TyumenSvg,
  [74]: ChelyabinskSvg,
  [75]: ChitaSvg,
  [76]: YaroslavlSvg,
  [1077]: MskSvg
};

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .mixin(tsStoreMixin)
  .create({
    name: 'MobileAppInvite',
    props: {
      siteName: {
        type: String,
        default: ''
      },
      appUrl: {
        type: String,
        default: ''
      },
      regionId: {
        type: Number as () => Regions,
        default: Regions.Nsk
      }
    },
    computed: {
      regionIcon(): string {
        return REGION_SVG_MAP[this.regionId];
      }
    },
    mounted() {
      this.appInviteMounted();
    },
    methods: {
      appInviteClicked(): void {
        this.$emit('appInviteClicked');
      },
      appInviteMounted(): void {
        this.$emit('appInviteMounted');
      }
    },
    render() {
      return (
        <div class={styles.mobileAppInvite}>
          <div class={styles.inner}>
            <div class={styles.logoWrap}>
              <img class={styles.logo} src={this.regionIcon} alt="" />
            </div>
            <div class={styles.text}>
              <p class={styles.siteName}>{this.siteName}</p>
              <p class={styles.tagline}>Читать в приложении</p>
            </div>
            <JtnUiBtn
              class={styles.btn}
              btnSize="small"
              href={this.appUrl}
              onClick={() => this.appInviteClicked()}
            >
              установить
            </JtnUiBtn>
          </div>
        </div>
      );
    }
  });
